import { Injectable, signal, Signal } from "@angular/core";
import { IType } from "@geolib/geoappbase-client";
import GeobusNavigationExtension from "./geobus-navigation.extension";


@Injectable({ providedIn: "root" })
export default class GeobusCommunityExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusCommunityExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.DATA.COMMUNITY").asReadonly();
    }

    public get category(): string {
        return "data";
    }

    public get state(): { name: string } {
        return { name: "app.gemeinden" };
    }

    public get icon(): string {
        return "pin";
    }

}
